import React, { useContext, HTMLAttributes } from "react";
import ConfigContext from "contexts/ConfigContext";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PageSection from "components/layout/PageSection";
import Spacer from "components/Spacer";
import DefaultAosAnimation from "components/aos/DefaultAosAnimation";
import StandardEdition from "./editions/StandardEdition";
import SpecialEdition from "./editions/SpecialEdition";
import Rotate from "components/rotate/Rotate";
import clsx from "clsx";
import titleImage from "assets/images/homePage/buyNowSection/title_buynow.png";
import useBackgroundStyles from "components/backgrounds/useBackgroundStyles";
import Addons from "./addons/Addons";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {},
        childContainer: {
            display: "flex",
            flexDirection: "column",
            [theme.breakpoints.down("sm")]: {
                alignItems: "center",
            },
        },
        titleContainer: {
            paddingTop: theme.spacing(2),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        editionsContainer: {
            paddingTop: theme.spacing(1),
            display: "flex",
            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
            },
        },
        edition: {
            maxWidth: 600,
            width: "50%",
            [theme.breakpoints.down("sm")]: {
                width: "100%",
            },
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function BuyNowSection(props: IProps) {
    const { className, id, ...rest } = props;
    const classes = useStyles();
    const backgrounds = useBackgroundStyles();

    const config = useContext(ConfigContext);

    const theme = useTheme();
    const mdScreen = useMediaQuery(theme.breakpoints.down("md"));
    const smScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <PageSection
            classes={{
                childContainer: classes.childContainer,
                skewedSectionRoot: backgrounds.default,
            }}
            skewed
            topSeparatorVariant="primary"
            className={clsx(className, classes.root)}
            {...rest}
        >
            <div className={classes.titleContainer} id={id}>
                <Rotate amount={-1}>
                    <img style={{ maxWidth: 250, width: "100%" }} src={titleImage} alt="" />
                </Rotate>
            </div>

            <Spacer />

            {typeof config === "undefined" ? null : (
                <>
                    <div className={classes.editionsContainer}>
                        <div className={classes.edition}>
                            <DefaultAosAnimation order={2}>
                                <Rotate amount={smScreen ? -1 : -2}>
                                    <StandardEdition />
                                </Rotate>
                            </DefaultAosAnimation>
                        </div>

                        <Spacer size={mdScreen ? 4 : 6} />
                        {smScreen ? <Spacer size={4} /> : null}

                        <div className={classes.edition}>
                            <DefaultAosAnimation order={3}>
                                <Rotate amount={1}>
                                    <SpecialEdition />
                                </Rotate>
                            </DefaultAosAnimation>
                        </div>
                    </div>

                    <Spacer size={4} />

                    <DefaultAosAnimation order={4}>
                        <Addons />
                    </DefaultAosAnimation>

                    <Spacer size={4} />
                </>
            )}
        </PageSection>
    );
}
